export class ConfirmDialogData {
  public message: string | undefined;
}